import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';

@Component({
    selector: 'app-date-field',
    templateUrl: './date-field.component.html',
    styleUrls: ['./date-field.component.scss'],
})
export class DateFieldComponent implements OnInit {
  @Input() label: string;
  @Input() inputName: string;
  @Input() form: UntypedFormGroup;
  @Input() isError: boolean;
  @Input() placeholder: string;
  @Input() uniqueId: string;
  @Input() isPlaceholderEnabled: boolean = false;
  @Input() preValue: string;
  @Output() dateChanged = new EventEmitter<string>();

  lastSelectedValue: any;
  isPickerOpen = false;

  constructor() {}

  ngOnInit() {
    if (this.preValue) {
      this.form.get(this.inputName)?.setValue(this.convertToISO(this.preValue));
      this.lastSelectedValue = this.convertToISO(this.preValue);
    }
  }

  get displayValue(): string {
    const val = this.form.get(this.inputName)?.value;
    if (!val) return '';
    const d = new Date(val);
    return isNaN(d.getTime()) ? '' : d.toLocaleDateString('en-GB', {day: 'numeric', month: 'short', year: 'numeric'});
  }

  openPicker() {
    this.lastSelectedValue = this.form.get(this.inputName)?.value;
    this.isPickerOpen = true;
  }

  onModalDismiss() {
    this.isPickerOpen = false;
  }

  convertToISO(dateString) {
    try {
      const newDate = new Date(dateString);
      if (isNaN(newDate.getTime())) {
        throw new Error('Invalid date');
      }
      const offset = newDate.getTimezoneOffset() * 60000;
      const localISOTime = new Date(newDate.getTime() - offset).toISOString().slice(0, -1);
      return localISOTime;
    } catch {
      return new Date().toISOString();
    }
  }

  onCancelClick() {
    this.form.get(this.inputName).setValue(this.lastSelectedValue);
    this.isPickerOpen = false;
  }

  async onConfirmClick() {
    try {
      const selectedDateTime = this.form.get(this.inputName).value;
      if (!selectedDateTime) {
        this.form.get(this.inputName).setValue(new Date().toISOString());
      }
      this.lastSelectedValue = this.form.get(this.inputName).value;
      this.dateChanged.emit(this.lastSelectedValue);
      this.isPickerOpen = false;
    } catch {
      this.lastSelectedValue = Date.now();
      this.isPickerOpen = false;
    }
  }

  onDateChange(event: any) {
    const newDate = event.detail.value;
    this.dateChanged.emit(newDate);
  }
}
